import { Outlet } from 'react-router-dom';

import { NotFoundError } from '@platform/core/errors';
import type { FeatureFlag } from '@platform/core/feature-flags';
import { useFeatureFlag } from '@platform/core/feature-flags';

type FeatureFlagGuardProps = React.PropsWithChildren<{
  featureFlag: FeatureFlag;
  shouldThrow?: boolean;
  actionProps?: ConstructorParameters<typeof NotFoundError>[0]['actionProps'];
}>;

export const FeatureFlagGuard = ({
  featureFlag,
  shouldThrow = true,
  actionProps = {
    to: '/',
    label: 'Go home',
  },
  children,
}: FeatureFlagGuardProps) => {
  const [isFeatureEnabled] = useFeatureFlag(featureFlag);

  if (!isFeatureEnabled) {
    if (!shouldThrow) {
      return null;
    }

    throw new NotFoundError({
      actionProps,
    });
  }

  return children || <Outlet />;
};
